import _ from 'lodash';
import { Model } from 'backbone';

export class TeamSnapshot extends Model {
	defaults() {
		return {
			round_rank: '-',
			rank: '-',
			num_teams: '-',
			// scoreflow: {},
			overall_score: '-',
			team_score: '-',
			actual_round_id: null,
			is_history_mode: false,
			points: '-'
		}
	}

	initialize() {
		this.prefix = 'teams_classic/';
		this.url = 'snapshot'
	}

	// parse({ success, result }) {
	// 	return success ? result[0] : {};
	// }

	calculateOverallScores() {
		const score = this.get('team_score');

		if(this.get('is_history_mode') || _.isUndefined(score)) {
			this.set({
				overall_score: _.sum(_(this.get('scoreflow'))
					.filter((rank, id) => {
						if (!this.get('history_round_id')) {
							return true;
						}
						return parseInt(this.get('history_round_id'), 10) >= parseInt(id, 10);
					})
					.values().value())
			});

			return this;
		}

		const overall_score = _.sum(_(this.get('scoreflow'))
			.omit(this.get('actual_round_id'))
			.values().value()
		);

		this.set({
			overall_score: overall_score + (parseInt(score, 10) || 0)
		});

		return this;
	}
}

export default TeamSnapshot;